<template>
  <base-page-layout title="Desempenho" class="desempenho" use-new-filters :filters="['lojas', 'segmentos']">
    <v-container class="px-0 pt-0" fluid grid-list-md>
      <v-layout row wrap>
        <v-flex v-for="(card, index) in cards" :key="index" xs3>
          <cbm-card
            :number-text="card.value"
            :title="card.text"
            :tooltip="card.helpText"
            :boolean-loader="loading"
            :quick-action="card.quickAction"
            :is-currency="card.isCurrency"
            :percent-text="card.underText"
            :percent-description="card.description"
            unset-percentage-colors
            simple-card
          />
        </v-flex>
      </v-layout>
    </v-container>

    <div class="d-flex flex-column desempenho">
      <clientes-ativos-chart />
      <percentual-faturamento-chart />
      <percentual-cupons-chart />
      <cupons-por-cliente-chart />
      <gasto-medio-por-cliente-chart />
      <cadastros-chart />
      <primeiras-compras-chart />
    </div>
  </base-page-layout>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import { DateTime } from 'luxon'

import BasePageLayout from '@/components/BasePageLayout.vue'
import CbmCard from '@/components/CbmCard.vue'
import CadastrosChart from '@/modules/clube/desempenho/views/pages/CadastrosChart.vue'
import PrimeirasComprasChart from '@/modules/clube/desempenho/views/pages/PrimeirasComprasChart.vue'
import ClientesAtivosChart from '@/modules/clube/desempenho/views/pages/ClientesAtivosChart.vue'
import PercentualFaturamentoChart from '@/modules/clube/desempenho/views/pages/PercentualFaturamentoChart.vue'
import PercentualCuponsChart from '@/modules/clube/desempenho/views/pages/PercentualCuponsChart.vue'
import CuponsPorClienteChart from '@/modules/clube/desempenho/views/pages/CuponsPorClienteChart.vue'
import GastoMedioPorClienteChart from '@/modules/clube/desempenho/views/pages/GastoMedioPorClienteChart.vue'
import { criteriaGroup, anyPurchaseCriteria, isLoyalCriteria } from '@/components/quick-actions/segmentationGroups.js'
import { localeString } from '@/config/helpers.js'

export default {
  components: {
    BasePageLayout,
    CbmCard,
    CadastrosChart,
    PrimeirasComprasChart,
    ClientesAtivosChart,
    PercentualFaturamentoChart,
    PercentualCuponsChart,
    CuponsPorClienteChart,
    GastoMedioPorClienteChart,
  },
  data: () => ({
    loading: true,
  }),
  computed: {
    ...mapState({
      stateFilters: (state) => state.filters,
      lastUpdate: (state) => state.lastUpdate,
    }),
    ...mapGetters({
      clientesCadastrados: 'clubeClientesCadastrados',
      clientesAtivos: 'clubeClientesAtivos',
      mediaCompras: 'clubeMediaCompras',
      gastoMedio: 'clubeGastoMedio',
    }),
    filter() {
      return {
        unidades: this.stateFilters.unitsConfiguration,
        date: [DateTime.fromFormat(this.lastUpdate.last_updated.toString(), 'yyyyMMdd').toFormat('yyyy-MM')],
        fidelidade: '1',
        segmentos: this.stateFilters.segments,
      }
    },
    cards() {
      return [
        {
          value: localeString(this.clientesCadastrados || 0),
          text: 'Clientes cadastrados no mês',
          isInteger: true,
          helpText: `Novos cadastros no mês de ${
            this.lastUpdate.last_updated ? DateTime.fromFormat(this.lastUpdate.last_updated.toString(), 'yyyyMMdd').toFormat('MMMM') : ''
          }`,
          // quickAction: {
          //   id: 'novos-cadastros',
          //   shortDescription: `Novos cadastros fidelidade`,
          //   longDescription: formatters => `Novos cadastros fidelidade - ${formatters.startDate} a ${formatters.endDate}`,
          //   segmentationGroup: quickActionFiltersCriteria =>
          //     criteriaGroup([
          //       signupDateCriteria(...quickActionFiltersCriteria.dateCriteriaFilter),
          //       isLoyalCriteria(true),
          //       ...quickActionFiltersCriteria.criteria.segments
          //     ])
          // }
        },
        {
          value: localeString(this.clientesAtivos || 0),
          text: 'Clientes clube ativos no mês',
          isInteger: true,
          quickAction: {
            id: 'clientes-ativos',
            shortDescription: `Clientes ativos`,
            longDescription: (formatters) => `Clientes ativos fidelidade - ${formatters.startDate} a ${formatters.endDate}`,
            segmentationGroup: (quickActionFiltersCriteria) =>
              criteriaGroup([
                anyPurchaseCriteria(...quickActionFiltersCriteria.dateCriteriaFilter),
                isLoyalCriteria(true),
                ...quickActionFiltersCriteria.criteria.segments,
                ...quickActionFiltersCriteria.criteria.units,
              ]),
          },
        },
        {
          value: localeString(this.mediaCompras || 0, 1),
          text: 'Média de cupons por cliente do clube',
        },
        {
          value: localeString(this.gastoMedio || 0, 2),
          text: 'Gasto médio por cliente no mês',
          isCurrency: true,
          loader: 'card-gasto-medio',
          helpText: `Faturamento de vendas identificadas dividido pelo número de clientes ativos no mês de ${
            this.lastUpdate.last_updated ? DateTime.fromFormat(this.lastUpdate.last_updated.toString(), 'yyyyMMdd').toFormat('MMMM') : ''
          }`,
        },
      ]
    },
  },
  async mounted() {
    this.$bus.$on('filter', this.getData)

    this.$nextTick(async () => {
      await this.getData()
    })
  },
  destroyed() {
    this.$bus.$off('filter')
  },
  methods: {
    ...mapWaitingActions({
      clubeClientesCadastrados: 'card-clientes-cadastrados',
      clubeClientesAtivos: 'card-clientes-ativos',
      clubeMediaCompras: 'card-media-compras',
      clubeGastoMedio: 'card-gasto-medio',
    }),
    async getData() {
      try {
        this.loading = true
        await Promise.all([
          this.clubeClientesCadastrados(this.filter),
          this.clubeClientesAtivos(this.filter),
          this.clubeMediaCompras(this.filter),
          this.clubeGastoMedio(this.filter),
        ])
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.desempenho {
  gap: 12px;
}
</style>
